import { createSlice } from "@reduxjs/toolkit";
import {
  fetchUserInfoBuilder,
  // getAdminUserInfoBuilder,
  logoutBuilder,
  refreshBuilder,
  sendCodeBuilder,
  verifyEmailBuilder,
} from "./builder";
import { LOGOUT } from "../../../utils/constants";

const initialState = {
  email: "",
  loggedIn: null,
  token: null,
  error: null,
  loginPending: false,
  verifyEmailPending: false,
  authLoading: true,
};

export const authSlice = createSlice({
  name: "authInfo",
  initialState,
  reducers: {
    setLoggedIn: (state, { payload }) => {
      state.loggedIn = payload.loggedIn;
    },
    setAccessToken: (state, { payload }) => {
      const { accessToken } = payload;
      state.token = accessToken;
    },
    setAuthLoading: (state, { payload }) => {
      state.authLoading = payload;
    },
  },
  extraReducers: (builder) => {
    sendCodeBuilder(builder);
    refreshBuilder(builder);
    logoutBuilder(builder);
    verifyEmailBuilder(builder);
    fetchUserInfoBuilder(builder);

    builder.addCase(LOGOUT, () => ({ ...initialState, loggedIn: false }));
  },
});

export const { setLoggedIn, setAccessToken, setAuthLoading } =
  authSlice.actions;

export const selectLoggedIn = (state) => state.authInfo.loggedIn;
export const selectToken = (state) => state.authInfo.token;

export const selectLoginPending = (state) => state.authInfo.loginPending;
export const selectAuthLoading = (state) => state.authInfo.authLoading;
export const selectVerifyEmailLoading = (state) =>
  state.authInfo.verifyEmailPending;

export default authSlice.reducer;
